import { WorkkyAgentElement } from "./element";

if (!customElements.get("workky-agent")) customElements.define("workky-agent", WorkkyAgentElement);

// Snippet-only usage: <script src=".../widget.js" data-workky-key="pk_…"> with no element → append one at the end of <body>.
const script = document.currentScript as HTMLScriptElement | null;
const key = script?.dataset.workkyKey;
if (key && !document.querySelector("workky-agent")) {
  const el = document.createElement("workky-agent");
  el.dataset.workkyKey = key;
  el.dataset.workkyApi = new URL(script!.src).origin;
  for (const k of ["workkyMode", "workkyTheme", "workkyAccent", "workkyPosition", "workkyLabel", "workkyOpen"] as const) {
    if (script?.dataset[k] !== undefined) el.dataset[k] = script.dataset[k];
  }
  const mount = () => document.body.appendChild(el);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount);
  else mount();
}
